import {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {Form, Formik} from 'formik'
import FormTextBox from 'src/cms/helpers/components/forms/FormTextBox'
import * as auth from '../redux/actions'
import {useDispatch, useSelector} from 'react-redux'
import {Link, useHistory, useLocation} from 'react-router-dom'
import {ISettingTypeState} from 'src/app/modules/siteSettings/components/settings'
import {isEmpty} from 'lodash'
import {
  clearOtpSession,
  getOtpDurationSeconds,
  getOtpSessionEmail,
  getOtpSessionExpiry,
  setOtpSession,
} from '../utils/otpSession'

const tokenSchema = Yup.object().shape({
  token: Yup.string().required('Token is required'),
})

export function OtpValidation() {
  const params: any = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const authResp = useSelector((state: any) => state.auth)
  const loading = authResp?.loading
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)
  const otpEmail = params.state?.email || getOtpSessionEmail()
  const [otpResendTime, setOtpResendTime] = useState(2)
  const [count, setCount] = useState(() => {
    const expiry = getOtpSessionExpiry()

    if (!expiry) {
      return getOtpDurationSeconds(2)
    }

    return Math.max(Math.ceil((expiry - Date.now()) / 1000), 0)
  })

  useEffect(() => {
    if (!otpEmail) {
      history.push({
        pathname: '/',
      })
    }
  }, [history, otpEmail])

  useEffect(() => {
    if (authResp?.accessToken) {
      clearOtpSession()
      dispatch(auth.actions.requestUser(authResp?.accessToken))
    }
  }, [authResp?.accessToken, dispatch])

  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['SMTP Settings']?.map((item: any) => {
          if (item?.name === 'otpResendTime') {
            setOtpResendTime(Number(item?.value) || 2)
          }
        })
    }
  }, [settingTypeData])

  useEffect(() => {
    if (!otpEmail) {
      return
    }

    const durationSeconds = getOtpDurationSeconds(otpResendTime)
    const storedExpiry = getOtpSessionExpiry()

    if (!storedExpiry) {
      setOtpSession(otpEmail, durationSeconds)
      setCount(durationSeconds)
    } else {
      setCount(Math.max(Math.ceil((storedExpiry - Date.now()) / 1000), 0))
    }
  }, [otpEmail, otpResendTime])

  useEffect(() => {
    const syncCountdown = () => {
      const expiry = getOtpSessionExpiry()

      if (!expiry) {
        setCount(0)
        return
      }

      setCount(Math.max(Math.ceil((expiry - Date.now()) / 1000), 0))
    }

    syncCountdown()

    const interval = window.setInterval(() => {
      syncCountdown()
    }, 1000)

    return () => {
      window.clearInterval(interval)
    }
  }, [])

  const handleResendOTP = () => {
    if (!otpEmail) {
      return
    }

    const durationSeconds = getOtpDurationSeconds(otpResendTime)
    setOtpSession(otpEmail, durationSeconds)
    setCount(durationSeconds)
    dispatch(auth.actions.resendOtp(otpEmail))
  }

  return (
    <>
      <h4 className='login-box-msg text-center mt-10 mb-3' data-cy='otp-validation-heading'>
        OTP{' '}
      </h4>
      <Formik
        initialValues={{}}
        validationSchema={tokenSchema}
        onSubmit={(values: {[key: string]: string}, {setSubmitting}) => {
          dispatch(auth.actions.otpVerify(values.token, otpEmail))
        }}
        data-cy='otp-validation-form'
      >
        {({isSubmitting, touched, handleChange, errors, values, setFieldValue}) => (
          <Form>
            <div className='pt-8'>
              <div className=''>
                <FormTextBox
                  labelClassName='col-md-12'
                  containerClassName='col-md-12'
                  type='text'
                  placeholder='Please enter otp'
                  name='token'
                  label='Enter OTP'
                  onChange={handleChange}
                  errors={errors}
                  touched={touched}
                  required={true}
                  data-cy='otp-validation-token-field'
                />
              </div>
              <div className='text-center my-2'>
                {count > 0 ? (
                  <div className='login-link fs-6 fw-bolder' data-cy='otp-validation-login-link'>
                    OTP expires in {count}s
                  </div>
                ) : (
                  <>
                    <button type='button' onClick={handleResendOTP} disabled={loading}>
                      Resend OTP
                    </button>
                  </>
                )}
              </div>
              <div className=''>
                <button
                  type='submit'
                  className='btn btn-lg w-100 mb-5'
                  disabled={loading}
                  data-cy='otp-validation-submit-button'
                >
                  {!loading && <span className='indicator-label'>Submit</span>}

                  {loading && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
                <div className='text-center mb-5'>
                  <Link
                    to='/auth/login'
                    className='login-link fs-6 fw-bolder'
                    data-cy='otp-validation-login'
                    onClick={clearOtpSession}
                  >
                    Go back
                  </Link>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}
